import createDocumentResource from 'src/actions/shared/createDocumentResource';
import { IsInt, Min, Max } from 'class-validator';

export class IdleTiming {
  @Max(4320, { message: 'Please enter a number of minutes that’s less than 3 days (4320 minutes)' })
  @Min(1, { message: 'Please enter a number of minutes that’s greater than 0' })
  @IsInt({ message: 'Please enter a whole number of minutes' })
  autoAwayMinutes: number;

  @Max(4320, { message: 'Please enter a number of minutes that’s less than 3 days (4320 minutes)' })
  @Min(1, { message: 'Please enter a number of minutes that’s greater than 0' })
  @IsInt({ message: 'Please enter a whole number of minutes' })
  autoOfflineMinutes: number;
}

const idleTimingResource = createDocumentResource<IdleTiming>({
  name: 'idleTiming',
  endpoint: 'v1/orgs/:orgId/configuration/agent',
  type: IdleTiming,
});
export default idleTimingResource;
